import { styled, Box, Typography, MenuItem } from "@mui/material";
import SecureAvatar from "components/common/SecureAvatar";

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  // borderRadius: theme.shape.borderRadius, // Optional, matching reference
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const WarningBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F9FAFB',
  border: '1px solid #E5E7EB',
  borderRadius: '8px',
  padding: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: '#6B7280',
  fontSize: '13px',

}));

export const WorkerDetailsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
}));

export const WorkerAvatar = styled(SecureAvatar)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: theme.shape.borderRadius,
}));

export const WorkerInfoText = styled(Box)({});

export const WorkerName = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '1rem', // Match design
}));

export const WorkerMetaText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '&.danger': {
    color: theme.palette.error.main,
  },
}));
